import { Form as AntdForm, Radio } from 'antd'
import { DateStyles } from 'components/DatePickerStyles/DatePickerStyles'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import RadioButton from 'components/Form/RadioButton'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export const FormItem = styled(AntdForm.Item)`
  margin-bottom: 0px !important;
`
export const Form = styled(AntdForm)`
  row-gap: 12px;
  display: flex;
  flex-direction: column;
  .ant-form-item {
    margin-bottom: 0 !important;
  }
`
export const TwoFields = styled(Flex)`
  gap: 12px;
`
export const TwoFieldsLabel = styled(Flex)`
  gap: 130px;
`
export const StyledDate = styled(DateStyles)`
  margin-top: 5px;
`
export const RadioGroup = styled(Radio.Group)`
  display: flex;
`
export const StyledRadio = styled(RadioButton)`
  margin-top: 10px;
`
export const SectionHeading = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  margin: 6px 0 8px 0;
  color: ${COLORS.GREY_T_20};
`
export const StyledInputDiv = styled(Flex)`
  margin-bottom: 20px !important;
  align-items: flex-end;
  position: sticky;
  align-items: baseline;
  width: 100%;
  border-radius: 8px;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-right: 0;
  }
`
export const FooterFlex = styled(Flex)`
  gap: 20px;
`
export const StyledInput = styled(Input)`
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
`
export const MarksFlex = styled(Flex)`
  gap: 20px;
  width: 40%;
`
export const SpinWrapper = styled(Flex)`
  padding-top: 30px;
  padding-bottom: 30px;
`